import api from "@/api";
import { UserMe } from "@/store/authStore";

export async function fetchMe() {
  const resp = await api.get<UserMe>("/users/me/");
  return resp.data;
}

type UpdateEmailResponse = {
  email: string;
};

export async function updateMyEmail(email: string) {
  const resp = await api.patch<UserMe>("/users/me/", {
    receipt_email: email,
  });

  return resp.data;
}

export async function updateSelectedPaymentMethod(
  selectedPaymentMethodId: string
) {
  const resp = await api.patch<UserMe>("/users/me/", {
    selected_payment_method_id: selectedPaymentMethodId,
  });

  return resp.data;
}

type AddPaymentMethodResponse = {
  confirmation_url: string;
  external_id: string;
  status: string;
};

export async function addPaymentMethod() {
  const resp = await api.post<AddPaymentMethodResponse>(
    "/users/me/payment-methods/add/"
  );

  return resp.data;
}

export async function deletePaymentMethod(paymentMethodId: string) {
  const resp = await api.delete<UserMe>(
    `/users/me/payment-methods/${encodeURIComponent(paymentMethodId)}/`
  );

  return resp.data;
}
